import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

import TextInput from '../../../../App/Components/Form/TextInput/TextInput'

import { IProps } from './IProps'

export const PasswordInputField: FunctionComponent<IProps> = ({
    setPersonPassword,
    setPasswordLengthError,
}) => {
    const { t } = useTranslation()

    return (
        <div
            style={{
                margin: '0.7em 0',
            }}
        >
            <TextInput
                label={t('Password *')}
                isRequired={true}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setPersonPassword(e.currentTarget.value)
                    if (e.currentTarget.value.length < 4) {
                        setPasswordLengthError(
                            `${t('Password must contain 4 characters or more')}`
                        )
                    } else {
                        setPasswordLengthError('')
                        setPersonPassword(e.currentTarget.value)
                    }

                    if (e.currentTarget.value.length === 0) {
                        setPasswordLengthError('')
                    }
                }}
                type={'password'}
            />
        </div>
    )
}
